import { denormalisedResponseEntities } from '../../sharetribe/utils/data';

export const fetchOwnListings = () => async (dispatch, getState, sdk) => {
  try {
    const res = await sdk.ownListings.query({
      pub_listingState: 'published',
      include: ['images'],
    });

    const ownListings = denormalisedResponseEntities(res);

    return ownListings;
  } catch (error) {
    console.error('Error fetching own listings:', error);
    throw error;
  }
};

export const checkListingAvailability =
  (listingId, start, end) => async (dispatch, getState, sdk) => {
    const res = await sdk.timeslots.query({
      listingId,
      start: new Date(start),
      end: new Date(end),
    });

    const timeSlots = res.data.data;

    // Return true if any slot fully covers the requested period
    return timeSlots.some((slot) => {
      const slotStart = new Date(slot.attributes.start);
      const slotEnd = new Date(slot.attributes.end);

      return slotStart <= new Date(start) && slotEnd >= new Date(end);
    });
  };
